import React from 'react';
import SaveFileDialog from './saveFileDialog';
import useSaveFileDialogStore from '@/utils/saveFileDialogService';

/**
 * 全局的 SaveFileDialog 管理器
 * 确保整个应用中只有一个 SaveFileDialog 实例
 */
const GlobalSaveFileDialog: React.FC = () => {
    const { visible, fileKey, hide } = useSaveFileDialogStore();

    return (
        <SaveFileDialog
            visible={visible}
            fileKey={fileKey}
            onClose={hide}
        />
    );
};

export default GlobalSaveFileDialog;
